module.exports = __webpack_public_path__ + "static/media/menton.d2057aa7.svg";